<template>
  <div class="pay-success-container">
    <div class="success-card">
      <!-- 成功标题 -->
      <h2 class="success-title">支付成功！</h2>
      <!-- 成功描述 -->
      <p class="success-description">
        您的支付已完成，感谢您的购买！您可在个人中心查看当前余额
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaySuccess',
  data() {
    return {
      // 可以在这里添加一些数据，比如订单号等
    }
  },
  methods: {

  },
  
  mounted() {
    // 页面加载完成后的处理
    console.log('支付成功页面已加载')
  }
}
</script>

<style scoped>
/* 全局样式重置，防止滚动条 */
* {
  box-sizing: border-box;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

/* 强制防止滚动条 */
html {
  overflow: hidden !important;
}

body {
  overflow: hidden !important;
}

/* 确保根元素不产生滚动 */
#app {
  height: 100vh;
  overflow: hidden;
}

.pay-success-container {
  height: 100vh;
  max-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  padding: 20px;
  overflow: hidden;
  box-sizing: border-box;
}

.success-card {
  background: white;
  border-radius: 16px;
  padding: 30px 30px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0);
  max-width: 400px;
  width: 100%;
  height: 400px; /* 设置高度与最大宽度相同 */
  max-height: 400px; /* 限制最大高度 */
  animation: slideUp 0.6s ease-out;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center; /* 确保卡片内所有文本居中 */
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.success-title {
  font-size: 36px; /* 字体大小36px */
  font-weight: 600; /* 字体粗细600 */
  color: #333;  /* 字体颜色#333 */
  margin: 0 0 20px 0; /* 上下间距20px */
  letter-spacing: 1px; /* 字间距1px */
  line-height: 1.2; /* 行高1.2 */
  text-align: center; /* 确保文本居中 */
  width: 100%; /* 占满宽度 */
}

.success-description {
  font-size: 18px; /* 字体大小18px */
  color: #666; /* 字体颜色#666 */
  margin: 0; /* 上下间距0 */
  line-height: 1.4; /* 行高1.4 */
  text-align: center; /* 确保文本居中 */
  width: 100%; /* 占满宽度 */
}

.action-buttons {
  display: flex; /* 弹性布局 */
  gap: 20px;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.primary-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.secondary-btn {
  background: #f5f7fa;
  color: #606266;
  border: 1px solid #dcdfe6;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.secondary-btn:hover {
  background: #ecf5ff;
  color: #409eff;
  border-color: #b3d8ff;
  transform: translateY(-2px);
}

.additional-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #67c23a;
}

.info-text {
  margin: 0;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.info-text i {
  color: #67c23a;
  font-size: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .pay-success-container {
    padding: 15px;
    height: 100vh;
    max-height: 100vh;
  }
  
  .success-card {
    padding: 25px 20px;
    max-width: 350px;
    width: 350px;
    height: 350px; /* 保持正方形 */
    max-height: 350px;
  }
  
  .success-title {
    font-size: 30px;
  }
  
  .success-description {
    font-size: 16px;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .primary-btn,
  .secondary-btn {
    width: 100%;
    max-width: 200px;
  }
}

@media (max-width: 480px) {
  .pay-success-container {
    height: 100vh;
    max-height: 100vh;
    padding: 10px;
  }
  
  .success-card {
    padding: 20px 15px;
    max-width: 300px;
    width: 300px;
    height: 300px; /* 保持正方形 */
    max-height: 300px;
  }
  
  .success-title {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .success-description {
    font-size: 14px;
    line-height: 1.3;
  }
}
</style>
